import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const StudentPhotosRedux = createActions(
  {
    getStudentPhotosRequest: ['params'],
    getStudentPhotosSuccess: ['data'],
    getStudentPhotosError: ['err'],
  },
  {
    prefix: 'STUDENT_PHOTOS_',
    defaultActions: {
    //   get: true,
    },
  },
)

const { Types, Creators } = StudentPhotosRedux
export const StudentPhotosTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

const getStudentPhotosRequest = state =>
  state.merge({ get: { fetching: true, error: null } }, d)

const getStudentPhotosError = (state, { err }) =>
  state.merge({ get: { fetching: false, error: err } }, d)

const getStudentPhotosSuccess = (state, data) => {
  return state.merge({ get: { fetching: false, results: data.data } }, d)
}

export const reducer = createReducer(
  INITIAL_STATE,
  {
    [Types.getStudentPhotosRequest]: getStudentPhotosRequest,
    [Types.getStudentPhotosSuccess]: getStudentPhotosSuccess,
    [Types.getStudentPhotosError]: getStudentPhotosError,
  },
  {
    defaultActions: {
    //   get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ParentPlatform/PhotosRedux.js